import { Box, MenuItem, Stack, Typography, useTheme } from "@mui/material";
import moment from "moment";
import React, { useRef } from "react";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import ServiceCard from "../../../components/serviceCard";
import TextInput from "../../../components/TextInputs";
import { CURRENCY } from "../../../constants/Variables";
import { getServiceDuration } from "../../../utils";
import CustomSelect from "./../../../components/customSelect/index";
import { t } from "i18next";
import { useSelector } from "react-redux";

const buttonStyle = {
  height: 40,
};

const DetailRow = ({ label, value }) => (
  <Stack direction="row" justifyContent="space-between" py={0.5}>
    <Typography variant="body1" fontWeight={500}>
      {label}:
    </Typography>
    <Typography
      variant="body1"
      color="text.secondary"
      // textTransform={"capitalize"}
    >
      {value || t("na")}
    </Typography>
  </Stack>
);

const AppointmentDetailsPage = ({
  appointmentDetails,
  updateWorkerStatus,
  updateAppointStatus,
  handleCloseMainDrawer,
}) => {
  const openConfirmDialog = useRef(null);
  const openRejectionDialog = useRef(null);
  const openAcceptDialog = useRef(null);
  const { palette } = useTheme();
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const renderAppointmentStatus = (event) => {
    if (
      event?.status === "pending" &&
      (event?.workerStatus === "pending" || event?.workerStatus === "accepted")
    ) {
      return (
        <Typography
          fontSize={"1.225rem"}
          color={"custom.pantoneGreen"}
          textTransform={"capitalize"}
        >
          {t("newAppointment")}
        </Typography>
      );
    }

    if (event?.status === "pending" && event?.workerStatus === "rejected") {
      return (
        <Typography fontSize={"1.225rem"} color={"custom.venetianRed"}>
          {t("appointmentRejected")}
        </Typography>
      );
    }

    if (event?.status == "accepted" && event?.workerStatus === "accepted") {
      return (
        <Typography fontSize={"1.225rem"} color={"custom.pantoneGreen"}>
          {t("startAppointment")}
        </Typography>
      );
    }

    if (event?.status === "started" && event?.workerStatus === "accepted") {
      return (
        <Typography fontSize={"1.225rem"} color={"custom.pantoneGreen"}>
          {t("completeAppointment")}
        </Typography>
      );
    }

    if (event?.status === "completed" && event?.workerStatus === "accepted") {
      return (
        <Typography fontSize={"1.225rem"} color={"custom.pantoneGreen"}>
          {t("appointmentCompleted")}
        </Typography>
      );
    }
  };

  const renderButtons = (event) => {
    if (event?.status === "completed" && event?.workerStatus === "accepted") {
      return (
        <Stack direction={"row"} spacing={1}>
          {/* <GlobalButton
            variant={"outlined"}
            btnText={"Download Invoice"}
            styleProps={buttonStyle}
            handleClickBtn={() => handleCloseMainDrawer()}
          /> */}
          <GlobalButton
            variant={"contained"}
            btnText={"okay"}
            styleProps={buttonStyle}
            handleClickBtn={() => handleCloseMainDrawer()}
          />
        </Stack>
      );
    } else if (
      event?.status === "started" &&
      event?.workerStatus === "accepted"
    ) {
      return (
        <Stack direction={"row"} spacing={1}>
          <GlobalButton
            variant={"contained"}
            btnText={"markAsCompleted"}
            styleProps={buttonStyle}
            handleClickBtn={() => {
              // openConfirmDialog.current.isVisible({
              //   type: "worker_appoitment_completed",
              // });
              updateAppointStatus("completed");
            }}
          />
        </Stack>
      );
    } else if (
      event?.status === "pending" &&
      event?.workerStatus === "pending"
    ) {
      return (
        <Stack direction={"row"} spacing={1}>
          <GlobalButton
            variant={"outlined"}
            btnText={"notAvailable"}
            styleProps={buttonStyle}
            handleClickBtn={() => openRejectionDialog.current.openDialog()}
          />
          <GlobalButton
            variant={"contained"}
            btnText={"accept"}
            styleProps={buttonStyle}
            handleClickBtn={() => openAcceptDialog.current.openDialog()}
          />
        </Stack>
      );
    }
  };

  const renderShippingAddress = (cardData) => {
    return (
      <Stack
        p={2}
        border={"1px solid"}
        borderColor={"text.borderGrey"}
        borderRadius={1}
      >
        <Stack direction={"row"} alignItems={"center"}>
          <Typography variant="body1">{`${cardData?.firstname} ${cardData?.lastname}`}</Typography>
          {/* <Typography variant="body1" ml={2}>
            {cardData?.contact}
          </Typography> */}
        </Stack>
        {/* <Typography variant="body2">{cardData?.email}</Typography> */}
        <Typography variant="body2">{cardData?.address}</Typography>

        <Typography variant="body2" color={"text.coolGrey"}>
          {cardData?.country} / {cardData?.state} / {cardData?.city} /{" "}
          {cardData?.zipCode}
        </Typography>
      </Stack>
    );
  };

  return (
    <>
      <Stack height={"100vh"} justifyContent={"space-between"}>
        {/* header */}
        <Stack
          p={2}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          borderBottom={`1px solid ${palette.custom.borderColor}`}
        >
          <Box>
            {/* current appointment status */}
            {renderAppointmentStatus(appointmentDetails)}
            <Typography variant="body2">
              {t("source")}:{" "}
              <span style={{ color: palette.custom.tartOrange }}>
                {appointmentDetails?.appointmentType}
              </span>
            </Typography>
          </Box>
          <Box>
            {/* current appointment status */}
            <Typography
              variant="body2"
              fontWeight={300}
              color={"custom.silverChalice"}
            >
              {moment(appointmentDetails?.start).format("MM/DD/YYYY")}
            </Typography>
            <Typography
              variant="body2"
              fontWeight={300}
              color={"custom.silverChalice"}
            >
              {moment(appointmentDetails?.start).format("dddd hh:mm a")}
            </Typography>
          </Box>
        </Stack>
        {/* All Services */}
        <Box p={2} height={"100%"} overflow={"auto"} sx={{}}>
          <Typography fontSize={"1.125rem"}>{t("services")}</Typography>

          {appointmentDetails?.companyServiceDetails && (
            <ServiceCard data={appointmentDetails} />
          )}

          <Stack>
            {appointmentDetails?.userInputs?.selectedType === "room+area" &&
              appointmentDetails?.userInputs?.selectedOption === "room" && (
                <DetailRow
                  label={t("userInput")}
                  value={`${appointmentDetails?.userInputs?.userInput} Room`}
                />
              )}
            {appointmentDetails?.userInputs?.selectedType === "room+area" &&
              appointmentDetails?.userInputs?.selectedOption === "area" && (
                <DetailRow
                  label={t("userInput")}
                  value={`${appointmentDetails?.userInputs?.userInput} m`}
                />
              )}

            {appointmentDetails?.userInputs.selectedType === "room+area" &&
              appointmentDetails?.userInputs.selectedOption === "apartment" && (
                <DetailRow
                  label={t("userInput")}
                  value={`${appointmentDetails?.userInputs?.userInput} m`}
                />
              )}
            {appointmentDetails?.userInputs.selectedType === "room+area" &&
              appointmentDetails?.userInputs.selectedOption === "deluxe" && (
                <DetailRow
                  label={t("userInput")}
                  value={`${appointmentDetails?.userInputs?.userInput} m`}
                />
              )}
            {appointmentDetails?.userInputs.selectedType === "area" &&
              appointmentDetails?.userInputs.selectedOption === "area" && (
                <DetailRow
                  label={t("userInput")}
                  value={`${appointmentDetails?.userInputs?.userInput} m`}
                />
              )}
            {appointmentDetails?.userInputs.selectedType === "fixed" &&
              appointmentDetails?.userInputs.selectedOption === "fixed" && (
                <DetailRow label={t("userInput")} value={`car`} />
              )}
            {appointmentDetails?.userInputs.selectedType ===
              "interior+exterior" &&
              appointmentDetails?.userInputs.selectedOption === "interior" && (
                <DetailRow label={t("userInput")} value={`Interior`} />
              )}
            {appointmentDetails?.userInputs.selectedType ===
              "interior+exterior" &&
              appointmentDetails?.userInputs.selectedOption === "exterior" && (
                <DetailRow label={t("userInput")} value={`Exerior`} />
              )}
            {appointmentDetails?.userInputs.selectedType ===
              "interior+exterior" &&
              appointmentDetails?.userInputs.selectedOption === "both" && (
                <DetailRow
                  label={t("userInput")}
                  value={`Interior + Exterior`}
                />
              )}
            {appointmentDetails?.userInputs?.cleaningType && (
              <DetailRow
                label={t("cleaningType")}
                value={appointmentDetails?.userInputs?.cleaningType}
              />
            )}
          </Stack>

          <Stack gap={1} my={2}>
            <Typography fontSize={"1.125rem"}>{t("clientAddress")}</Typography>
            {renderShippingAddress(appointmentDetails?.location)}
          </Stack>

          {appointmentDetails?.clientAnswers?.length > 0 && (
            <>
              <Typography fontSize={"1.125rem"}>
                {t("clientAnswers")}
              </Typography>
              <Stack
                gap={0.4}
                my={2}
                p={2}
                border={"1px solid"}
                borderColor={"text.borderGrey"}
                borderRadius={1}
              >
                {appointmentDetails?.clientAnswers?.map((val, index) => {
                  return (
                    <Box key={index}>
                      <Typography>
                        Q. {val.question[currentLanguage]}
                      </Typography>
                      <Typography color="text.slateGray">
                        A. {val.answer}
                      </Typography>
                    </Box>
                  );
                })}
              </Stack>
            </>
          )}

          {appointmentDetails?.notes && (
            <>
              <Typography fontSize={"1.125rem"}>{t("noteMessage")}</Typography>
              <TextInput value={appointmentDetails?.notes} multiline rows={3} />
            </>
          )}
        </Box>
        <Stack
          spacing={0.5}
          p={2}
          borderTop={`1px solid ${palette.custom.borderColor}`}
        >
          {appointmentDetails?.workerStatus !== "rejected" && (
            <Stack mt={2}>
              <Label labelText={t("appointmentStatus")} required />
              <CustomSelect
                value={appointmentDetails?.status}
                onChange={(e) => updateAppointStatus(e.target.value)}
                disabled={true}
              >
                <MenuItem value={"pending"}>{t("pending")}</MenuItem>
                <MenuItem value={"accepted"}>{t("arrived")}</MenuItem>
                <MenuItem value={"started"}>{t("started")}</MenuItem>
                <MenuItem value={"completed"}>{t("completed")}</MenuItem>
              </CustomSelect>
            </Stack>
          )}

          <Stack
            mt={0.3}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="h6" fontWeight={500}>
              {t("total")}
            </Typography>
            <Stack direction={"row"} alignItems={"center"} gap={3}>
              <Typography variant="body2">
                {getServiceDuration(
                  appointmentDetails?.start,
                  appointmentDetails?.end
                )}
              </Typography>
              <Typography variant="h6" fontWeight={500}>
                {`${CURRENCY} ${appointmentDetails?.totalCost}`}
              </Typography>
            </Stack>
          </Stack>
          {/* {renderButtons(appointmentDetails)} */}
        </Stack>
      </Stack>
      {/* <ConfirmationDialog ref={openConfirmDialog} /> */}

      {/* <RejectAppointmentDialog
        ref={openRejectionDialog}
        handleSendRejectReason={(reason) =>
          updateWorkerStatus("rejected", reason)
        }
      />
      <AcceptAppointmentDialog
        ref={openAcceptDialog}
        handleAccepetAppointment={() => {
          updateWorkerStatus("accepted");
          openAcceptDialog.current.closeDialog();
        }}
      /> */}
    </>
  );
};

export default AppointmentDetailsPage;
